export default {
  // Navbar
  "nav.category": "Kategorie wählen",
  "nav.cta1": "Oopbuy Spreadsheet",
  "nav.cta2": "Buy It Now",
  "nav.home": "Startseite",
  "nav.shopping_guide": "Shopping Guide",

  // Categories
  "cat.shoes": "Schuhe",
  "cat.hoodies": "Hoodies & Sweater",
  "cat.tshirts": "T-Shirts",
  "cat.jackets": "Jacken",
  "cat.pants": "Hosen & Shorts",
  "cat.headwear": "Kopfbedeckungen",
  "cat.sets": "Sets",
  "cat.underwear": "Unterwäsche",
  "cat.jersey": "Trikots",
  "cat.accessories": "Accessoires",
  "cat.bags": "Taschen",
  "cat.belts": "Gürtel",
  "cat.perfumes": "Parfums",
  "cat.other": "Sonstiges",

  // Hero
  "hero.users": "10.000+ Nutzer in Deutschland",
  "hero.title1": "Oopbuy",
  "hero.title2": "Spreadsheet",
  "hero.subtitle": "Die smarte Einkaufs-Spreadsheet-Lösung für organisiertes Online-Shopping. Verwalte alle deine Bestellungen an einem Ort.",

  // Feature Grid
  "feature.title": "Beliebte Kategorien",
  "feature.desc": "Entdecke unsere meistgesuchten Produktkategorien. Mit Oopbuy Spreadsheet behältst du den Überblick über alle deine Einkäufe – von Schuhen bis Accessoires.",
  "feature.shop_now": "Jetzt shoppen",

  // All Categories
  "allcat.title": "Alle Kategorien",
  "allcat.desc": "Entdecke alle Produktkategorien auf Oopbuy Spreadsheet – von Schuhen über Kleidung bis zu Accessoires.",

  // About
  "about.label": "Warum Oopbuy Spreadsheet?",
  "about.text": "Oopbuy Spreadsheet revolutioniert die Art, wie du online einkaufst. Behalte den Überblick, spare Geld und shoppe smarter als je zuvor. ✨",

  // Articles
  "articles.eyebrow": "Oopbuy Guides",
  "articles.title": "Spreadsheet Tipps & Tricks",
  "articles.desc": "Lerne alles über Oopbuy Spreadsheet – von den Grundlagen bis zu fortgeschrittenen Strategien. Unsere Guides helfen dir, das Beste aus deinem Einkaufserlebnis herauszuholen.",
  "articles.tag": "Buying Guide",
  "articles.tag_shipping": "Versand Guide",
  "articles.tag_qc": "QC Guide",
  "articles.tag_compare": "Vergleich",
  "articles.read_more": "Weiterlesen",
  // Existing 3 articles
  "articles.guide1_title": "Oopbuy Spreadsheet: Der komplette Guide für Einsteiger",
  "articles.guide1_desc": "Erfahre alles über Oopbuy Spreadsheet – von der Einrichtung bis zu Profi-Tipps.",
  "articles.guide2_title": "Wie nutzt man Oopbuy Spreadsheet richtig?",
  "articles.guide2_desc": "Praktische Tipps und Tricks für den optimalen Einsatz deines Einkaufs-Spreadsheets.",
  "articles.guide3_title": "Oopbuy Spreadsheet vs. Traditionelles Shopping",
  "articles.guide3_desc": "Warum immer mehr Deutsche auf Oopbuy Spreadsheet umsteigen.",
  // Shipping Guide articles (3)
  "articles.shipping1_title": "Oopbuy Spreadsheet Versand: Der komplette Shipping-Guide",
  "articles.shipping1_desc": "Alles über Versandoptionen, Lieferzeiten und Tracking mit Oopbuy Spreadsheet.",
  "articles.shipping2_title": "Internationaler Versand mit Oopbuy Spreadsheet",
  "articles.shipping2_desc": "So funktioniert der weltweite Versand – von Deutschland bis weltweit.",
  "articles.shipping3_title": "Versandkosten sparen: Oopbuy Spreadsheet Tipps",
  "articles.shipping3_desc": "Mit diesen Tricks sparst du bei jeder Bestellung Versandkosten.",
  // QC Guide articles (3)
  "articles.qc1_title": "Oopbuy Spreadsheet QC: Qualitätskontrolle einfach erklärt",
  "articles.qc1_desc": "Wie die Qualitätsprüfung bei Oopbuy Spreadsheet abläuft.",
  "articles.qc2_title": "QC-Prozess: So schützt Oopbuy Spreadsheet deine Bestellungen",
  "articles.qc2_desc": "Sicherheit geht vor – der vollständige QC-Workflow im Detail.",
  "articles.qc3_title": "Oopbuy Spreadsheet QC-Checkliste für Einsteiger",
  "articles.qc3_desc": "Worauf du bei der Qualitätskontrolle achten solltest.",
  // Vergleich articles (3)
  "articles.compare1_title": "Oopbuy Spreadsheet vs. Manuelle Excel-Tabellen",
  "articles.compare1_desc": "Warum ein spezialisiertes Tool besser ist als DIY-Lösungen.",
  "articles.compare2_title": "Oopbuy Spreadsheet im Vergleich zu Shopping-Apps",
  "articles.compare2_desc": "Die Vor- und Nachteile verschiedener Shopping-Tools im Überblick.",
  "articles.compare3_title": "5 Gründe: Warum Oopbuy Spreadsheet die beste Wahl ist",
  "articles.compare3_desc": "Die entscheidenden Vorteile auf einen Blick zusammengefasst.",

  // Testimonials
  "testimonial.quote": "„Oopbuy Spreadsheet hat meine Art einzukaufen komplett verändert. Ich spare monatlich über 200 € und finde immer die besten Deals. Absolut empfehlenswert!\"",
  "testimonial.name": "Markus Weber",
  "testimonial.role": "Zufriedener Nutzer seit 2024",
  "testimonial.cta": "Mehr Erfahrungen lesen",

  // CTA
  "cta.title": "oopbuy spreadsheet",
  "cta.desc1": "Die clevere Lösung für organisiertes Online-Shopping.",
  "cta.desc2": "Kostenloser Versand innerhalb Deutschlands.",
  "cta.button": "Zum Shop",

  // Footer
  "footer.products": "Produkte",
  "footer.guides": "Guides",
  "footer.support": "Support",
  "footer.legal": "Rechtliches",
  "footer.guide_link": "Oopbuy Spreadsheet Guide",
  "footer.shipping_link": "Versand Guide",
  "footer.qc_link": "QC Guide",
  "footer.compare_link": "Vergleich",
  "footer.faq": "FAQ",
  "footer.about": "Über uns",
  "footer.contact": "Kontakt",
  "footer.privacy": "Datenschutz",
  "footer.terms": "AGB",
  "footer.imprint": "Impressum",
  "footer.tagline": "Die smarte Einkaufs-Spreadsheet-Lösung",
  "footer.copyright": "© 2025 Oopbuy Spreadsheet",
}